import * as inflection from 'inflection';
import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import Button from '../../components/Button';
import { useAllGroupMap } from '../../groups/useAllGroups';
import CommentWarning from './CommentWarning';

interface GroupNotificationCommentWarningProps {
  groupIds: string[];
  isNotifyingEnabled: boolean;
  onChange(isNotifyingEnabled: boolean): void;
}

const GroupNotificationCommentWarning = ({
  groupIds,
  isNotifyingEnabled,
  onChange,
}: GroupNotificationCommentWarningProps) => {
  const groupMap = useAllGroupMap();
  const currentUserId = useAppSelector((state) => state.session.user.id);

  const userIds = new Set(
    groupIds
      .flatMap((id) => groupMap[id]?.allUsers.map((user) => user.id) ?? [])
      .filter((id) => id !== currentUserId),
  );

  const userCount = userIds.size;

  if (userCount <= 1) {
    return null;
  }

  return (
    <CommentWarning>
      {isNotifyingEnabled ? (
        <>
          {userCount} {inflection.inflect('person', userCount)} will be
          notified.{' '}
          <Button onClick={() => onChange(false)} variant="link" size="small">
            Skip notifying
          </Button>
        </>
      ) : (
        <>
          Notification skipped.{' '}
          <Button onClick={() => onChange(true)} variant="link" size="small">
            Enable notifying
          </Button>
        </>
      )}
    </CommentWarning>
  );
};

export default GroupNotificationCommentWarning;
